// api-clients.js
import axios from 'axios';
import * as store from '@/app/store/index';

declare module 'axios' {
  export interface AxiosRequestConfig {
    setLoadingAction?: boolean;
  }
}

const apiClient = axios.create({
  baseURL: process.env.MOCK_API || '/api',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    if (config.setLoadingAction !== false) {
      store.default.dispatch('loader/setLoadingAction', true);
    }
    return config;
  },
  (error) => {
    if (error.config.setLoadingAction !== false) {
      store.default.dispatch('loader/setLoadingAction', false);
    }
    return Promise.reject(error);
  },
);

apiClient.interceptors.response.use(
  (response) => {
    if (response.config.setLoadingAction !== false) {
      store.default.dispatch('loader/setLoadingAction', false);
    }
    return response;
  },
  (error) => {
    if (error.name !== 'CanceledError') {
      if (error.config.setLoadingAction !== false) {
        store.default.dispatch('loader/setLoadingAction', false);
      }
      if (error.response.status === 401) {
        window.location = '/';
      } else {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
